// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_m4C","cls2":"WorkCard-cls2_ZBU WorkCard-cls1_m4C"};